import React, { FC } from 'react';
import styled from '@emotion/styled';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { Button } from '~Styles';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import CategoryIcon from '~Assets/icons/category.svg';
import { useI18n } from '~Hooks';

const Dimmer = styled.div`
  z-index: 1;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  touch-action: none;
  overscroll-behavior: contain;
`;

const LinkButton = styled(NavLink)`
  text-decoration: none;
`;

/** Rendered if the category navigated to in POS is out of stock */
const OutOfStockDimmer: FC = () => {
  const { i18n } = useI18n();
  const match = useRouteMatch<{ id: string }>();

  return (
    <Dimmer>
      <ModalWrapper
        width="440px"
        padding="large"
        header={{
          icon: CategoryIcon,
          title: i18n('Inventory.CategoryIsOutOfStock'),
          subtitle: i18n('Inventory.CategoryIsOutOfStock.Desc'),
        }}>
        <LinkButton to={`/venue/${match.params.id}/inventory`}>
          <Button fluid>{i18n('Menu.InventoryManagment')}</Button>
        </LinkButton>
      </ModalWrapper>
    </Dimmer>
  );
};

export default OutOfStockDimmer;
